import React from "react";
import "./App.css";

export default function Header() {
  return <div className="Header">The Weather Station</div>;
}
